// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import css from './index.inline.styl';
import {template} from './template';

export type SwitchChangeEvent = CustomEvent<{on: boolean}>;

export interface SwitchJsxProps {
  attrs: {
    disabled?: boolean;
    on: boolean;
    icon?: string;
    showcase?: boolean;
    'show-icon-while-off'?: boolean;
  };
  on?: {
    change: (ev: SwitchChangeEvent) => void;
  };
}

export class Switch extends Component<EmptyObj, SwitchJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<SwitchJsxProps['attrs']> {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      on: `boolean`,
      icon: {
        type: `string`,
        description: `controls which icon should appear when switch is on. Defaults to the checkmark icon`,
      },
      showcase: {
        type: `boolean`,
        description: `show pulsing box shadow effect when the switch is off and showcase mode is on`,
      },
      'show-icon-while-off': {
        type: `boolean`,
        description: `show the icon while the switch is off`,
      },
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {},
      helpers: {
        toggleSwitch: () => {
          this.dispatchEvent(new CustomEvent(`change`, {detail: {on: !this.attr(`on`)}}));
        },
      },
    };
  }
}

export const SwitchEl = defineAndMakeJsxFactory<SwitchJsxProps>(`mp-switch`, Switch);
export const SwitchReact = panel2react<SwitchJsxProps>(`mp-switch`, Switch);
